import { Component, Input, OnInit } from '@angular/core';

interface ClassroomAPIResponse {
  success: boolean;
  code?: number;
  data?: any; // API request data
  response?: any; // API response object
}

@Component({
  selector: 'app-single-guardian-log-entry',
  templateUrl: './single-guardian-log-entry.component.html',
  styleUrls: ['./single-guardian-log-entry.component.scss'],
})
export class SingleGuardianLogEntryComponent implements OnInit {
  @Input() data;
  @Input() debug;
  @Input() showErrorsOnly;

  panelOpenState = false;
  error = false;
  statusIcon = 'check';
  rendered: string;

  constructor() {}

  ngOnInit() {
    this.error = !!this.data.error;
    this.statusIcon = this.getStatusIcon();
    this.rendered = this.getRendered();
  }

  getRendered() {
    let rtn = '';
    switch (this.data.action) {
      case 'resendWithdrawInvitation':
        rtn = `<em>Withdrew current invitation</em> to <strong>${this.data.guardian}</strong> for student <strong>${this.data.student}</strong>`;
        break;
      case 'resendSendInvitation':
        rtn = `<em>Invitation resent</em> to <strong>${this.data.guardian}</strong> for student <strong>${this.data.student}</strong>`;
        break;

      case 'withdrawInvitation':
        rtn = `<em>Withdrew invitation</em> to <strong>${this.data.guardian}</strong> for student <strong>${this.data.student}</strong>`;
        break;

      case 'removeGuardian':
        rtn = `Guardian <strong>${this.data.guardian}</strong> <em>removed</em> from student <strong>${this.data.student}</strong>`;
        break;

      case 'sendInvitation':
        rtn = `<em>Invitation sent</em> to <strong>${this.data.guardian}</strong> for student <strong>${this.data.student}</strong>`;
        break;

      default:
        rtn = JSON.stringify(this.data);
    }

    return rtn;
  }

  _parseErrorCode(response: ClassroomAPIResponse): string {
    let rtn = response.success ? 'SUCCESS' : 'FAIL';
    if (response.code && response.code !== 200) {
      switch (response.code) {
        case 409:
          rtn += ` : 409 Already exists`;
          break;
        case 404:
          rtn += ` : 404 Not found`;
          break;
        case 403:
          rtn += ` : 403 Permission denied`;
          break;
        default:
          rtn += ` : ${response.code} API error encountered`;
          break;
      }
    }
    return rtn;
  }

  getStatusIcon() {
    return this.error ? 'error' : 'check';
  }
}
